import styled from 'styled-components';
import { FlexColumn, FlexRow } from '@make-software/tg-mini-app-ui';

export const ModalRoot = styled(FlexColumn)`
  height: 100%;
  width: 100%;
`;

export const HeaderRow = styled(FlexRow)`
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
`;

export const Title = styled.div`
  font-size: 15px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.2px;
`;

export const ContentArea = styled(FlexColumn)`
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
  gap: 12px;
  -webkit-overflow-scrolling: touch;
`;

export const StickyFooter = styled(FlexColumn)`
  margin-top: auto;
  padding: 12px 16px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: #30313b;
  gap: 10px;
`;

export const Section = styled(FlexColumn)`
  gap: 6px;
  padding: 12px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

export const Hint = styled.div`
  font-size: 12px;
  color: #a9aaad;
  line-height: 1.35;

  b {
    color: #fff;
    font-weight: 800;
  }
`;

export const Steps = styled(FlexColumn)`
  gap: 8px;
  margin-top: 8px;
`;

export const StepRow = styled(FlexRow)`
  gap: 10px;
  align-items: center;
`;

export const StepIndex = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  flex: 0 0 22px;
`;

export const StepText = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.25;
`;

export const FooterRow = styled(FlexRow)`
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const OtpBox = styled(FlexColumn)`
  gap: 10px;
  margin-top: 8px;
  padding: 12px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

export const OtpRow = styled(FlexRow)`
  align-items: center;
  justify-content: center;
  padding: 10px 0 2px;
`;

export const OtpValue = styled.div`
  font-size: 26px;
  font-weight: 900;
  letter-spacing: 6px;
  color: #ffffff;
  line-height: 1;
  user-select: text;
`;

export const OtpMetaRow = styled(FlexRow)`
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const OtpPill = styled.div`
  font-size: 12px;
  color: #ffffff;
  font-weight: 800;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const InlineLinkButton = styled.button`
  border: none;
  background: transparent;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
